import VueApexCharts from 'vue3-apexcharts';
import type { App } from 'vue';

/**
 * Custom ApexCharts plugin that adds global configuration to prevent errors
 * like the "translate(NaN, 0)" issue with empty data
 */
export const apexChartsPlugin = {
  install(app: App) {
    // Register the component
    app.use(VueApexCharts);
    
    // Add global defaults for ApexCharts to prevent NaN errors
    // These will be merged with individual chart options
    app.config.globalProperties.$apexchartsConfig = {
      chart: {
        animations: {
          dynamicAnimation: {
            enabled: true
          }
        },
        // Global error handlers
        events: {
          beforeMount: function(chart: any) {
            // Check for empty data and replace with non-zero values
            if (chart.w.config.series) {
              const series = chart.w.config.series;
              if (Array.isArray(series)) {
                for (let i = 0; i < series.length; i++) {
                  if (series[i].data && series[i].data.length === 0) {
                    series[i].data = [0.01]; // Small non-zero value
                  }
                }
              }
            }
          },
          beforeResetDynamicAnimation: function(chart: any) {
            // This prevents some animation-related NaN issues
            // when chart data or options change
          },
          noData: function(chart: any) {
            // Provide a callback for the no data event
            // to add additional logic if needed
          },
          error: function(chart: any, options: any, err: any) {
            // Error handler
          }
        }
      },
      // Ensure categories always have values
      xaxis: {
        convertedCatToNumeric: true
      }
    };
  }
};

export default apexChartsPlugin; 